import { render, staticRenderFns } from "./TwoFactorAuthPage.vue?vue&type=template&id=6768faae&scoped=true&"
import script from "./TwoFactorAuthPage.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthPage.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorAuthPage.vue?vue&type=style&index=0&id=6768faae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6768faae",
  null
  
)

export default component.exports